import { RootState } from '../store';

export const titleSelector = (state: RootState): string => state.pageTitle.title;
